import { render, staticRenderFns } from "./registerGuide.vue?vue&type=template&id=0229230e&scoped=true&"
import script from "./registerGuide.vue?vue&type=script&lang=js&"
export * from "./registerGuide.vue?vue&type=script&lang=js&"
import style0 from "./registerGuide.vue?vue&type=style&index=0&id=0229230e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229230e",
  null
  
)

export default component.exports